import { handleAuthRedirect } from './auth-redirect';

handleAuthRedirect().then((handled) => {
  if (handled) {
    // The bridge completes iframe responses or navigates back after a redirect, so the app is not needed here.
  } else {
    import('./the-hive.js');
  }
}).catch(() => {
  // An unusable response must not leave a blank page; the app starts and signs in again, which the
  // reader sees as the sign-in prompt.
  import('./the-hive.js');
});
